import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { ChainWideCradlepointsComponent } from '@app/features/cradlepoints/modules/chain-wide-cradlepoints/chain-wide-cradlepoints.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    declarations: [
        ChainWideCradlepointsComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class ChainWideCradlepointsModule {}